AFRAME.registerComponent("box-link-button", {
  init() {
    this.parentEl = this.el.parentEl.parentEl;
    this.createBox.bind(this);

    const interval = setInterval(() => {
      if (this.parentEl.components["media-loader"].loaded) {
        this.createBox();

        return clearInterval(interval);
      }
    }, 100);
  },
  createBox() {
    const epsilon = 1e-10;

    const mesh = this.parentEl.object3DMap.mesh;
    const box = new THREE.Box3().setFromObject(mesh);

    const rotation = this.parentEl.object3DMap.object3d?.parent?.rotation;
    const isRotatedFloor = rotation?.x < -0.5 || rotation?.x > 0.5;

    const boxSize = new THREE.Vector3();
    box.getSize(boxSize);

    const isPlane =
      mesh.geometry && (mesh.geometry.type === "PlaneBufferGeometry" || mesh.geometry.type === "PlaneGeometry");

    // Add workaround for planes
    if (mesh.geometry && isPlane && Math.abs(boxSize.z) > epsilon) {
      const x = boxSize.x;
      const z = boxSize.z;

      boxSize.x = z;
      boxSize.z = x;
    }

    if (boxSize.z === 0) {
      boxSize.z = 0.01;
    }

    const boxGeometry = new THREE.BoxGeometry(
      boxSize.x,
      boxSize.y,
      isPlane && boxSize.z !== 0.01 && !isRotatedFloor ? boxSize.z * 0.1 : boxSize.z
    );

    const boxMaterial = new THREE.MeshBasicMaterial({
      color: 0xffffff,
      transparent: true,
      opacity: 0,
      side: THREE.DoubleSide,
      depthWrite: false,
      depthTest: false
    });

    const boxMesh = new THREE.Mesh(boxGeometry, boxMaterial);
    boxMesh.position.set(0, 0, 0);
    if (isRotatedFloor) {
      boxMesh.rotation.set(rotation.x, rotation.y, rotation.z);
    }

    this.el.setObject3D("box", boxMesh);
  }
});
